import React, { useEffect, useRef, useState } from 'react'
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import { useToast } from '../../../../Components/Others/ToastServices';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import SendOTP from './SendOTP';
import {BackButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import NewCommonDynamicForm from '../../../../Components/Utils/NewCommonDynamicForm';
import { GetAccess, GetRole } from '../../../../Components/Utils/roles';
import EditIcon from '../../../../Components/Icons/Edit';

function FormOpen() {
     const collectorSign = useRef(null);
  const clientSign = useRef(null);

  const [collectorDataURL, setCollectorDataURL] = useState(null);
  const [clientDataURL, setClientDataURL] = useState(null);

  const [isCollectorSignEnabled, setIsCollectorSignEnabled] = useState(false);
  const [isClientSignEnabled, setIsClientSignEnabled] = useState(false);
  const [signOne, setSignOne] = useState(null);
  const [signTwo, setSignTwo] = useState(null);
  const [filesList, setFileList] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");
  const [showActionButtons, setShowActionButtons] = useState(false);
  const [showClientActionButtons, setShowClientActionButtons] = useState(false);
  const { scheduleViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);
     const location = useLocation();
   
const form = location.state?.form;
console.log(form,'form');

  const toast = useToast();

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState(false);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  useEffect(() => {

    if (scheduleViewId) 
    fetchAllForm(scheduleViewId);

        fetchTasks(scheduleViewId);

  }, [scheduleViewId]);

  const fetchTasks = async (value) => {
    try {
      // setLoading(true);
      const response = await axiosInstance.get(`/schedules/forms/${value}`);
      console.log("Form ID", response.data?.data);
      const Data = response.data?.data;
      setisSubmittted(response?.data?.isSubmitted === false);
      setAllFormValues(Data);
      checkAllSubmitted();
      checkOtpEnable();
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      // setLoading(true);
      const formResponse = await axiosInstance.get(
        `/schedules/form-fields/${value}`
      );
      console.log(formResponse.data?.data);
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          console.log("Field - getting", field);
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      // setLoading(false);
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const handleToggle = (index, id) => {
    setAllForm([]);
    fetchAllForm(id);
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let ValuesForForm = {
        isSubmitted: true,
        values: allValue,
        filesToRemove: [],
        oldSign1: removeSignOne || "",
        oldSign2: removeSignTwo || "",
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      filesList &&
        filesList.map((item) => {
          formData.append("attachments", item);
        });
      signOne &&
        formData.append(
          "signature1",
          signOne,
          `signature1-${formId}-${new Date().toISOString()}.png`
        );
      signTwo &&
        formData.append(
          "signature2",
          signTwo,
          `signature2-${formId}-${new Date().toISOString()}.png`
        );
      axiosInstance
        .put(`/schedules/form-submition/${formId}`, formData)
        .then((res) => {
          console.log("Form Submitted", res.data);
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            CloseEditForm(formId);
          } else {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
            setShowErrorFeild(true);
            setErrorMessage(res.data?.data || "Network error.");
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    },
  });

  function SaveFormData() {
    let ValuesForForm = {
      isSubmitted: false,
      values: allValue,
      filesToRemove: [],
      oldSign1: removeSignOne || "",
      oldSign2: removeSignTwo || "",
    };
    let formData = new FormData();
    formData.append("json_data", JSON.stringify(ValuesForForm));
    filesList &&
      filesList.map((item) => {
        formData.append("attachments", item);
      });
    signOne &&
      formData.append(
        "signature1",
        signOne,
        `signature1-${formId}-${new Date().toISOString()}.png`
      );
    signTwo &&
      formData.append(
        "signature2",
        signTwo,
        `signature2-${formId}-${new Date().toISOString()}.png`
      );

    axiosInstance
      .put(`/schedules/form-submition/${formId}`, formData)
      .then((res) => {
        if (res.data?.status === true) {
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
          CloseEditForm(formId);
        } else {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      });
  }

  async function CloseEditForm(formId) {
  try {
    const res = await axiosInstance.put(`/schedules/close-form/${formId}`);
    if (res?.data?.status) {
      setEditModeIndex(null);
      fetchTasks(formId);
    } else {
      toast.open({
        type: "error",
        message: "Error",
        description: res.data?.msg || "Network error.",
      });
    }
  } catch (error) {
    toast.open({
      type: "error",
      message: "Error",
      description: error?.response?.data?.msg || "Network error.",
    });
  }
}

 async function OpenEditForm(formId, workingUser) {
  if (workingUser) {
    CloseEditForm(formId);
  } else {
    try {
      const res = await axiosInstance.put(`/schedules/open-form/${formId}`);
      if (res?.data?.status) {
        fetchTasks(formId);
        setEditModeIndex(formId); // Set edit mode to the form ID
      } else {
        toast.open({
          type: "error",
          message: "Error",
          description: res.data?.msg || "Network error.",
        });
      }
    } catch (error) {
      toast.open({
        type: "error",
        message: "Error",
        description: error?.response?.data?.msg || "Network error.",
      });
    }
  }
}
  const [open, setOpen] = useState(false);

  const handleSendOTP = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/schedules/check-submitted/${scheduleViewId}`
      );
      console.log("Check Submitted Status", response.data);
      // fetchTasks(scheduleViewId)

      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);
  useEffect(() => {
    const interval = setInterval(() => {
      if (collectorSign.current) {
        collectorSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (collectorSign.current) {
      isCollectorSignEnabled
        ? collectorSign.current.on()
        : collectorSign.current.off();
    }
  }, [isCollectorSignEnabled]);

  // Client
  useEffect(() => {
    const interval = setInterval(() => {
      if (clientSign.current) {
        clientSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (clientSign.current) {
      isClientSignEnabled ? clientSign.current.on() : clientSign.current.off();
    }
  }, [isClientSignEnabled]);

  const [otpEnable, setOtpEnable] = useState(false);

  const [openEnable, setEnableOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch OTP enable status
  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setOtpEnable(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setOtpEnable(false);
    }
  };

  // On button click, open confirm popup
  const handleEnableOTP = () => setEnableOpen(true);

  // On confirm, call verify API
  const handleVerifyOTP = () => {
    setLoading(true);
    axiosInstance
      .put(`/schedules/verify-otp/${scheduleViewId}`, { opt: "" })
      .then((res) => {
        if (res.data.status) {
          toast.open({
            type: "success",
            message: "OTP Verified",
          });
          fetchTasks(scheduleViewId);
        } else {
          toast.open({
            type: "error",
            message: "Invalid OTP",
            description: res.data.msg,
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Network Error",
          description: err.message,
        });
      })
      .finally(() => {
        setLoading(false);
        setEnableOpen(false);
      });
  };

  // On page load, check status and fetch tasks
  useEffect(() => {
    checkOtpEnable();
    fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  useEffect(() => {
    if (allForm?.signature1?.file) {
      setRemoveSignOne(allForm?.signature1?.file);
    }
    if (allForm?.signature2?.file) {
      setRemoveSignTwo(allForm?.signature2?.file);
    }
  }, [allForm]);
  return (
    <>
 <div className="py-4 px-4 overflow-hidden h-[calc(100vh-80px)] flex flex-col"> 
 <div className="sm:flex justify-between w-full mb-4">
  <Breadcrumb
    items={[
      {
        name: "Form",
        link: `/inspection/schedule/newform/${scheduleViewId}`
      },
      {
      name: form?.formName || "Form Details",
    },
    ]}
  />
  <div className='flex gap-2 justify-end'>
  {GetAccess("inspection_schedule_form_edit") && (GetRole() || isSubmittted) && (
  <span
    onClick={() => OpenEditForm(scheduleViewId, form?.workingUser)}
    className={`cursor-pointer mr-4 rounded-md p-1 border 
      ${
        editModeIndex === scheduleViewId
          ? "bg-green-100 border-green-500"
          : "bg-red-100 border-red-500"
      }`}
  >
    <EditIcon
      color={editModeIndex === scheduleViewId ? "green" : "red"}
      height={16}
    />
  </span>
)}
  <BackButton />
</div>
</div>
  <div className="bg-white flex-1 overflow-y-auto rounded-md ">
    <form onSubmit={formik.handleSubmit}>
      <NewCommonDynamicForm
        formData={allForm?.titles || []}
        formik={formik}
        allValue={allValue}
        setAllValue={setAllValue}
        SaveFormData={SaveFormData}
        editModeIndex={!!editModeIndex}
        FileAttachment={setFileList}
        SignOne="Inspector"
        SignTwo="Client"
        setSignFunOne={setSignOne}
        setSignFunTwo={setSignTwo}
        allData={allForm}
        setFileRemoveList={setFileRemoveList}
        fileRemoveList={fileRemoveList}
        setRemoveSignOne={setRemoveSignOne}
        setRemoveSignTwo={setRemoveSignTwo}
      />
    </form>

    {/* {allSubmitted && isSubmittted && otpEnable && (
      <div className="w-full p-4 flex justify-end">
        <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
      </div>
    )}
    {!otpEnable && isSubmittted && (
      <div className="w-full p-4 flex justify-end">
        <SubmitButton name="Verify" handleClick={handleEnableOTP} />
      </div>
    )} */}
  </div>

  {/* Modals */}
  {/* {open && (
    <SendOTP
      scheduleViewId={scheduleViewId}
      onClose={() => setOpen(false)}
      fetchTasks={fetchTasks}
    />
  )}
  {openEnable && (
    <ModalContainer
      visiable={openEnable}
      title="Confirm"
      content={
        <div>
          <p>
            Are You Sure! You want to{" "}
            <span className="font-semibold">Verify</span> this Form?
          </p>
        </div>
      }
      handleClick={handleVerifyOTP}
      closeModal={() => setEnableOpen(false)}
      isLoading={loading}
    />
  )} */}

  {showErrorFeild && (
    <ModalContainer
      closeModal={() => setShowErrorFeild(false)}
      visiable={showErrorFeild}
      title=""
      hasButton={false}
      content={
        <div className="max-w-[65vw] max-h-[90vh] min-h-[30vh] 2xl:min-w-[45vw]">
          <div className="w-full h-7 mb-2 flex justify-between items-center">
            <p className="font-semibold text-sm">Fields to be checked</p>
            <div className="flex gap-4 items-center">
              <button
                className="text-white bg-red-600"
                onClick={() => {
                  setShowErrorFeild(false);
                  setErrorMessage("");
                }}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="w-full max-h-[calc(90vh-32px)] overflow-y-auto">
            <pre>{ErrorMessage}</pre>
          </div>
        </div>
      }
    />
  )}
</div>
       
 </> )
}

export default FormOpen